var ExportViaDownload = (function (backOffice, $) {
    backOffice.ExportViaDownload = (function () {
        const ModalSelector = '#export-via-download-modal'
        const EmailNotificationCheckbox = "#email-notify"
        const EmailInputForm = '#email-input-form'
        const EmailInput = '#email-input'
        const EmailValidationError = '#email-validation-error'
        const ExportAsExcelButton = '#btnExportExcel'
        const ExportAsCsvButton = '#btnExportCsv'
        const ExportAsExcelButtonName = 'Export as Excel';
        const ExportAsCsvButtonName = 'Export as CSV';
        const ExportQueuedButtonName = 'Export Queued'

        var csvButtonNameBeforeCheckChange;
        var csvButtonDisabledBeforeCheckChange;
        var excelButtonNameBeforeCheckChange;
        var excelButtonDisabledBeforeCheckChange;
        var customerServiceEmail = undefined;

        function openModal(job, openCallbackFn, closedCallbackFn, csvExportBtnDisplayed = true, excelExportBtnDisplayed = true) {
            initModal(job, openCallbackFn, closedCallbackFn, csvExportBtnDisplayed, excelExportBtnDisplayed);
            fetchCustomerServiceEmail();
            fetchCurrentUserEmail();
            $(ModalSelector).modal('show');
        }

        function closeModal() {
            $(ModalSelector).modal('hide');
        }

        function exportAsExcel() {
            self.job.ExportFormat = BackOffice.Constants.ReportExportFormats.EXCEL;
            createExportJob(ExportAsExcelButton, function () {
                toggleButtonAvailability(ExportAsExcelButton, self.excelExportBtnDisplayed, false);
                updateButtonName(ExportAsExcelButton, self.excelExportBtnDisplayed, ExportQueuedButtonName);
            });
        }

        function exportAsCsv() {
            self.job.ExportFormat = BackOffice.Constants.ReportExportFormats.CSV;
            createExportJob(ExportAsCsvButton, function () {
                toggleButtonAvailability(ExportAsCsvButton, self.csvExportBtnDisplayed, false);
                updateButtonName(ExportAsCsvButton, self.csvExportBtnDisplayed, ExportQueuedButtonName);
            });
        }

        function redirectToExportManager() {
            let encodedTargetUrl = encodeURIComponent("/DOTNET/Admin/Applications/MassProcessing.aspx?target_url=/export-manager");
            let fullTargetUrl = `${window.location.origin}/default.asp?FrameRedirect=${encodedTargetUrl}`;
            window.open(fullTargetUrl, "_blank").focus();
        }

        function initModal(job, openCallbackFn, closedCallbackFn, csvExportBtnDisplayed, excelExportBtnDisplayed) {
            self.job = job;
            self.openCallBackFn = openCallbackFn;
            self.closeCallBackFn = closedCallbackFn;
            self.csvExportBtnDisplayed = csvExportBtnDisplayed;
            self.excelExportBtnDisplayed = excelExportBtnDisplayed;
            self.csvExportJobCreatedWithEmail = false;
            self.excelExportJobCreatedWithEmail = false;

            attachEventHandlers();

            handleControlsVisibility();
        }

        function handleControlsVisibility() {

            if (!self.csvExportBtnDisplayed) {
                hideElement(ExportAsCsvButton)
            }
            if (!self.excelExportBtnDisplayed)
                hideElement(ExportAsExcelButton);

            makeInvisible(EmailInputForm);
        }

        function toggleButtonAvailability(selector, displayed, enabled) {
            if (displayed) {
                toggleElementAvailability(selector, enabled)
            }
        }

        function toggleElementAvailability(selector, enabled) {
            $(selector).prop('disabled', !enabled);
        }

        function createExportJob(exportButtonSelector, success, error) {
            if ($(EmailNotificationCheckbox).is(":checked")) {
                setJobNotificationParams(exportButtonSelector);
                BackOffice.JobService.Create(self.job, true, success, error);
                // to prevent next export without notifity option having notifications set
                clearJobNotificationParams();
                
            } else {
                BackOffice.JobService.Create(self.job, true, success, error);
            }
        }

        function setJobNotificationParams(exportButtonSelector) {
            self.job.Notifications = {
                Email: {
                    From: customerServiceEmail ? customerServiceEmail : BackOffice.Constants.DefaultSystemEmail,
                    To: [$(EmailInput).val()]
                }
            };
            
            switch (exportButtonSelector) {
                case ExportAsCsvButton:
                    self.csvExportJobCreatedWithEmail = true;
                    break;
                case ExportAsExcelButton:
                    self.excelExportJobCreatedWithEmail = true;
                    break;
            }
        }

        function clearJobNotificationParams() {
            self.job.Notifications = null;
        }

        function attachEventHandlers() {
            $(ModalSelector).on("shown.bs.modal", function () {
                $(ModalSelector).find(".modal-overlay").removeClass("active").hide();
                if (self.openCallBackFn) {
                    self.openCallBackFn();
                }
            });

            $(ModalSelector).on("hidden.bs.modal", function () {
                if (self.closeCallBackFn) {
                    self.closeCallBackFn();
                }

                detachEventHandlers();
                resetEmailControls();
                resetButtons();

                $('.modal-backdrop').remove();
            });

            $(EmailNotificationCheckbox).on("change", function (e) {

                if ($(EmailNotificationCheckbox).is(":checked")) {
                    csvButtonNameBeforeCheckChange = $(ExportAsCsvButton).html();
                    csvButtonDisabledBeforeCheckChange = $(ExportAsCsvButton).is(":disabled");
                    excelButtonNameBeforeCheckChange = $(ExportAsExcelButton).html();
                    excelButtonDisabledBeforeCheckChange = $(ExportAsExcelButton).is(":disabled");

                    makeVisible(EmailInputForm);

                    if (!self.csvExportJobCreatedWithEmail || !self.excelExportJobCreatedWithEmail) {

                        if (!self.csvExportJobCreatedWithEmail) {
                            updateButtonName(ExportAsCsvButton, self.csvExportBtnDisplayed, ExportAsCsvButtonName);
                        }
                        if (!self.excelExportJobCreatedWithEmail) {
                            updateButtonName(ExportAsExcelButton, self.excelExportBtnDisplayed, ExportAsExcelButtonName);
                        }

                        validateEmailAndToggleExportButtonsAvailability();
                        validateCustomerServiceEmail();

                        $(EmailInput).off('change').on("change", function (e) {
                            validateEmailAndToggleExportButtonsAvailability();
                            validateCustomerServiceEmail();
                        });
                    }
                } else {
                    makeInvisible(EmailInputForm);

                    if (!self.csvExportJobCreatedWithEmail) {
                        updateButtonName(ExportAsCsvButton, self.csvExportBtnDisplayed, csvButtonNameBeforeCheckChange);
                        toggleButtonAvailability(ExportAsCsvButton, self.csvExportBtnDisplayed, !csvButtonDisabledBeforeCheckChange);
                    }

                    if (!self.excelExportJobCreatedWithEmail) {
                        updateButtonName(ExportAsExcelButton, self.excelExportBtnDisplayed, excelButtonNameBeforeCheckChange);
                        toggleButtonAvailability(ExportAsExcelButton, self.excelExportBtnDisplayed, !excelButtonDisabledBeforeCheckChange);
                    }
                }
            });

            $(EmailInput).on("keyup keypress", function (e) {
                var keyCode = e.keyCode || e.which;
                if (keyCode === 13) {
                    e.preventDefault();
                    return false;
                }
            });
        }

        function fetchCustomerServiceEmail() {
            BackOffice.SettingsService.Get(BackOffice.Constants.SystemSettingNames.CustomerServiceEmail, false, function (emailSetting) {
                customerServiceEmail = emailSetting.value;
                validateCustomerServiceEmail();
            });
        }

        function fetchCurrentUserEmail() {
            BackOffice.SettingsService.GetCurrentUserEmail(false, function (emailID) {
                $(EmailInput).val(emailID);
            });
        }
        function detachEventHandlers() {
            $(ModalSelector).off('hidden.bs.modal');
            $(ModalSelector).off('shown.bs.modal');
            $(ModalSelector).off('change');
            $(EmailNotificationCheckbox).off('change');
            $(EmailInput).off("change");
            $(EmailInput).off("keyup keypress");
        }

        function resetEmailControls() {
            $(EmailNotificationCheckbox).prop("checked", false);
            $(EmailInput).val("");
        }

        function resetButtons() {
            resetButtonNames();
            toggleButtonAvailability(ExportAsCsvButton, self.csvExportBtnDisplayed, true);
            toggleButtonAvailability(ExportAsExcelButton, self.excelExportBtnDisplayed, true);
        }

        function resetButtonNames() {
            updateButtonName(ExportAsCsvButton, self.csvExportBtnDisplayed, ExportAsCsvButtonName);
            updateButtonName(ExportAsExcelButton, self.excelExportBtnDisplayed, ExportAsExcelButtonName);
        }

        function showElement(selector) {
            $(selector).show();
        }

        function hideElement(selector) {
            $(selector).hide();
        }

        function makeVisible(selector) {
            $(selector).css('visibility', 'visible');
        }

        function makeInvisible(selector) {
            $(selector).css('visibility', 'hidden');
        }

        function validateEmailAndToggleExportButtonsAvailability() {
            var valid = validateEmail();

            if (!self.csvExportJobCreatedWithEmail) {
                toggleButtonAvailability(ExportAsCsvButton, self.csvExportBtnDisplayed, valid);
            }
            if (!self.excelExportJobCreatedWithEmail) {
                toggleButtonAvailability(ExportAsExcelButton, self.excelExportBtnDisplayed, valid);
            }
        }

        function validateEmail() {
            var errorMessage = "";

            var email = $(EmailInput).val();

            var emailValid = backOffice.Utils.ValidateEmail(email);

            if (!email) {
                errorMessage = "Email Is Required."
            }
            else if (!emailValid) {
                errorMessage = "Email Appears Invalid."
            }

            $(EmailValidationError).html(errorMessage);

            return emailValid;
        }

        function validateCustomerServiceEmail() {
            var errorMessage = $(EmailValidationError).html();

            if (customerServiceEmail === null || customerServiceEmail === '') {
                if (errorMessage) {
                    errorMessage += "<br/>";
                }
                errorMessage += "Customer Service \"From\" Email Address is Not Populated in Global Settings.";
            }
            $(EmailValidationError).html(errorMessage);
        }

        function updateButtonName(selector, displayed, text) {
            if (displayed) {
                $(selector).html(text);
            }
        }

        return $.extend(backOffice.ExportViaDownload, {
            Open: openModal,
            Close: closeModal,
            ExportAsExcel: exportAsExcel,
            ExportAsCsv: exportAsCsv,
            RedirectToExportManager: redirectToExportManager
        });
    })();


    return backOffice.ExportViaDownload;
})(BackOffice || {}, jQuery);